import keycloak from '@/keycloak';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import TreeView from '@mui/lab/TreeView';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarItem from './SidebarItem';

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('sidebar');
  const isAdmin =
    keycloak.hasResourceRole('ADMIN', process.env.REACT_APP_KEYCLOAK_CLIENT_ID) || process.env.REACT_APP_ENV === 'dev';

  const selectedTree = (endpoint: string) => {
    if (endpoint.startsWith('/projects')) {
      return '2';
    }
    switch (endpoint) {
      case '/imports':
        return '1';
      case '/projects':
        return '2';
      case '/admin':
        return '3';
      default:
        return '1';
    }
  };
  return (
    <TreeView
      selected={selectedTree(location.pathname)}
      defaultExpanded={['1']}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
      sx={{ height: 264, flexGrow: 1, width: 280, paddingLeft: '2rem' }}
    >
      <>
        <SidebarItem
          active={selectedTree(location.pathname) === '1'}
          nodeId="1"
          labelText={t('periods')}
          labelInfo="2,294"
          color="#e3742f"
          bgColor="#fcefe3"
          badgeColor="warning"
          onClick={() => {
            navigate('imports');
          }}
        />
        <SidebarItem
          active={selectedTree(location.pathname) === '2'}
          nodeId="2"
          labelText={t('projects')}
          labelInfo="2,294"
          color="#e3742f"
          bgColor="#fcefe3"
          badgeColor="warning"
          onClick={() => {
            navigate('projects');
          }}
        />
      </>

      {isAdmin && (
        <>
          <Typography variant="h2" sx={{ marginY: '1rem', fontWeight: 'bold' }}>
            {t('Administração')}
          </Typography>
          <SidebarItem
            active={selectedTree(location.pathname) === '3'}
            nodeId="3"
            labelText={t('Admin')}
            color="#e3742f"
            bgColor="#fcefe3"
            onClick={() => {
              navigate('admin');
            }}
          />
        </>
      )}
    </TreeView>
  );
}
